import type { CalendarEvent } from 'owa-calendar-types';
import type { CreateCollabSpaceOnInitProps } from 'owa-calendar-helpers-types';

export const removeDownlevelLink = (eventBody: string) => {
    const downlevelLinkRegex = '<div id="?(?:x_)*FluidCollaborativeSpace"?[\\w\\W]+?</div>';
    const downlevelLink = eventBody.match(downlevelLinkRegex);
    if (downlevelLink?.length > 0) {
        eventBody = eventBody.replace(downlevelLink[0], '');
    }
    return eventBody;
};

export async function getFtdfCreateCollabSpaceOnInitProps(
    event: CalendarEvent
): Promise<CreateCollabSpaceOnInitProps | null> {
    if (event.CollabSpace?.enabled) {
        const createCollabSpaceOnInitProps: CreateCollabSpaceOnInitProps = {
            shouldCreateCollabSpace: true,
            collabSpaceCreationSource: 'FTDF_Flow',
        };
        return createCollabSpaceOnInitProps;
    }
    return null;
}
